// only whitelist these vaults on testnet created before the TESTNET_WHITELIST_TIMESTAMP
export const USDEVaultAddress = 'inj1r86atmuulmhzw63pqx5tp989nmupvn4fd94m7u'

export const testnetWhitelistedVaults: string[] = [
  'inj1uavssa4h4s73h5fdqlheytyl6c8mvl89yfuuq9',
  'inj14dz74tz06lxz2pl4e5vcv3v62lst8d43rp6hy4',
  'inj1kxdfjs4tnu88aaqhvl9caja9qq9fs4r5qmpwqj',
  'inj1qaq7mkvuc474k2nyjm2suwyes06fdm4kt26ks4',
  'inj1vd0mf8a39xwr9hav2g7e8lmur07utjrjv025kd',
  'inj1xqsp96842fsht7m6p4slvrfhl53wfqft866sc7',
  'inj1fgdlfyru0e0fk4tsxtdz6an7vfwz3g82w40qy6',
  'inj1qamlsmj22p3zkchgva2ydhegfwz3ls7m5sm7rs',
  'inj1ckmdhdz7r8glfurckgtg0rt7x9uvner4ygqhlv',
  'inj1v4s3v3nmsx6szyxqgcnqdfseucu4ccm65sh0xr',
  'inj196f5hz8x7laqyfykr6sf6f6qjkna2gd2eqvdcy',
  'inj1xvlnfmq5672rmvn6576rvj389ezu9nxc9dpk8l', // projx-inj
  'inj1w9hnzhlq26wdgw3d2gh9fvf3nwnvxe6ff5crdj' // zen-inj
]

export const mainnetWhitelistedVaults: string[] = [
  USDEVaultAddress, // USDe/USDT
  'inj1v8v8jepsjdsxj29hxmm62qwzmg54r75v6mq6q9', // DOJO
  'inj1ve3uga90prrwtpsptjrhnxlfd9u0qwuf0v43ke', // TALIS
  'inj1hw4vgqyvgw5vca224mpg2e0ccqguhnu7yawpu8', // NINJA
  'inj12hrath9g2c02e87vjadnlqnmurxtr8md7djyxm', // QUNT
  'inj14xy8dvgjyhqjn8dhegf9zz5g7c3yeflt0kgarp', // INJ/USDT,
  'inj1sqj6x44uxtmklyewqxk9frqjrkjqjjmu6u0mrm', // WHALE
  'inj15s4c3kqa0j6glrgppcn0h357jac40ndyptv3sr', // ANDR
  'inj1zxk9xvs6mnq2m5yws8gdgqstrmcqntuedlnua3', // HYDRO/INJ
  'inj1ckyym37k9u3gne0qdcpu7ty20p59d3lutepkge', // ZIG
  'inj1r4pjz70l4ytk06dfparzd6na5qqjeq09fkxdt4', // PYTH
  'inj14gmk6jg5kduvy882yjdq4967e46jaka7ffuf58', // LVN
  'inj1wzt78jy575ejcps76gpc2m8k2v4x2526aksnk0', // ENA
  'inj1xar9nfhqc9al47hkh7eljrc3g66lntqch8hh0r', // XIII
  'inj16vjf4nnyqvjws6chw6u3t3kmujhllj4wjn9nlh', // BLACK
  'inj1a9hcr7zf5a2ahkv5fvumyky50ww7ds2cg5tk95', // GINGER
  'inj17jdcvmkpvhgwfnukxjt6uvu2cptuqv309rz8pu', // ASG
  'inj1rayjg2wktsj9aa9j5ps52v3qunn80m7fjhdstp', // AUTISM
  'inj1p9djw5xkg7dfgteqnh3cqmef2xs6meycd2k5r5', // NONJA
  'inj1sm36lxmzynkt9q37nwspf8n6pzplktul006u08', // KIRA
  'inj15599wr9jzgrt6e04xkue9l6409mlc3l7lqr38d', // MOTHER,
  'inj13ph6mqgzq6kve2rnzzdfe65p7ren8ys5p9rgv6', // HDRO/USDT
  'inj15dc3yyptzcq7ggehelh0e5taq6twm7a29vyms9' // NBZ/USDT
]

export const mainnetBlacklistedVaults: string[] = [
  'inj14qvrrqm8pf6ad072f27kjj0fmdavkpd0mtjc8t' // Phuc test
]

export const mainnetBlacklistedPermissonlessVaults: string[] = [
  'inj1xkq56rjtpcqgwh9yut6zwh3lxcle2yz4dljyxc'
]

export const ninjaPassExclusiveVaults: Record<string, number> = {
  inj14xy8dvgjyhqjn8dhegf9zz5g7c3yeflt0kgarp: 1708965000000
}

export const vaultTvlOverrides: Record<string, number> = {
  // inj14xy8dvgjyhqjn8dhegf9zz5g7c3yeflt0kgarp: 2_000_000
}

export const stakeDecimalsOverride: Record<string, number> = {
  inj1xar9nfhqc9al47hkh7eljrc3g66lntqch8hh0r: 18, // XIII
  inj16vjf4nnyqvjws6chw6u3t3kmujhllj4wjn9nlh: 18 // BLACK
}

export const CPMMV1Vaults = [
  'inj1q0jekx8qgsne2us8nfjewkmljzdyaz6zs3lykz', // devnet test
  'inj1v8v8jepsjdsxj29hxmm62qwzmg54r75v6mq6q9', // DOJO
  'inj1ve3uga90prrwtpsptjrhnxlfd9u0qwuf0v43ke', // TALIS
  'inj1hw4vgqyvgw5vca224mpg2e0ccqguhnu7yawpu8', // NINJA
  'inj14xy8dvgjyhqjn8dhegf9zz5g7c3yeflt0kgarp' // INJ
]

export const vaultCta: Record<string, string> = {
  [USDEVaultAddress]: 'UsdeCta'
}
